// components/PopupVendor/VendorBanner.js
import React from 'react';

const VendorBanner = ({
                          currentBackgroundImage,
                          currentLogo,
                          name,
                          isCurrentUserVendorOwner,
                          handleLogoChange,
                          handleBackgroundImageChange
                      }) => {
    return (
        <div className="profile__headline profile__headline-company"
             style={{background: `url(${currentBackgroundImage || '/assets/bg--profile-vendor.jpg'})`}}>
            <div className="container">
                <div className="profile__logo">
                    {currentLogo && (
                        <picture>
                            <source type="image/webp" srcSet={currentLogo}/>
                            <source type="image/jpg" srcSet={currentLogo}/>
                            <img src={currentLogo} alt={`${name || 'Vendor'} logo`}/>
                        </picture>
                    )}
                    {isCurrentUserVendorOwner && (
                        <label className="userpick__edit">
                            <img src="/assets/icon--edit-bg-BVfPEI-f.svg" alt="Edit Logo"/>
                            <input type="file" onChange={handleLogoChange} accept="image/*"/>
                        </label>
                    )}
                </div>
                {isCurrentUserVendorOwner && (
                    <label className="bg__edit">
                        <div className="button no-style">
                            <img src="/assets/icon--edit-Z9QfuMgm.svg" alt="Edit Background"/> Edit Big Photo
                        </div>
                        <input type="file" onChange={handleBackgroundImageChange} accept="image/*"/>
                    </label>
                )}
            </div>
        </div>
    );
};

export default VendorBanner;